import { Edit, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import BackButtonToolbar from "features/BackButtonToolbar";

const transform = ({ nameBg, nameEn, studyForms }) => ({
  nameBg,
  nameEn,
  studyForms: (studyForms ?? []).map(
    ({ studyTypeId, instructionLanguageId, annualFee }) => ({
      studyTypeId,
      instructionLanguageId,
      annualFee: annualFee ?? null,
    }),
  ),
});

const EditDoctoralPrograms = () => {
  return (
    <Edit
      title="Редакция на докторантска програма"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
      transform={transform}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};

export default EditDoctoralPrograms;
